<template>
    <div class="wrapper">
        <div name="error-modal" class="modal">
        
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <span class="title">에러 발생</span>
                <span class="error">{{ error }}</span>
                <div class="button" @click="onClose">확인</div>
            </div>
        </div>
    </div>
</template>

<script>
// error modal 

export default {
    name: 'errorModal',
    props: ['error'],
    methods: {
        onClose : function()
        {
            this.$emit('onClose');
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        height: calc(100vh - 267px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 267px;
        width: calc(100%);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }

    .error {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 20px;
    }
    .button {
        display: flex;
        width: calc(100% - 32px);
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
    }

</style>


// WEBPACK FOOTER //
// src/components/modals/ErrorModal.vue